import { indexedDBService } from "../../dexie/indexedDBService";

/**
 * responsible for get the current user and current roles and schemas
 */
class MainPagePresenter {
  constructor(
    view,
    getCurrentUserUseCase,
    signOutUseCase,
    getSchemaUseCase,
    findObjectUseCase,
  ) {
    this.view = view;
    this.getCurrentUserUseCase = getCurrentUserUseCase;
    this.signOutUseCase = signOutUseCase;
    this.getSchemaUseCase = getSchemaUseCase;
    this.findObjectUseCase = findObjectUseCase;
  }

  componentDidMount() {
    this.init();
    this.startPolling();
  }

  async init() {
    this.view.showProgress();
    try {
      await this.getUser();
      await this.getSchema();
      this.view.hideProgress();
    } catch (error) {
      this.view.hideProgress();
      switch (error.code) {
        case 401:
          this.view.navigateTo("/signin");
          break;
        case 403:
          this.view.navigateTo("/app");
          break;
        default:
          this.view.showError(error);
      }
    }
  }

  async getUser() {
    try {
      const user = await this.getCurrentUserUseCase.execute();
      this.user = user;
      if (!user.roles && !this.user.isMaster) {
        this.view.navigateTo("/denied");
        return;
      }
      // if (!user.isActive) {
      //   this.view.navigateTo("/denied");
      //   return;
      // }
      this.view.setCurrentRoles(user.roles || []);
      this.view.setCurrentUser(user);
    } catch (error) {
      throw error;
    }
  }

  async getSchema() {
    try {
      const schemas = await this.getSchemaUseCase.execute();
      this.view.setSchemas(schemas);
    } catch (error) {
      throw error;
    }
  }

  onClickSignOut() {
    const options = {
      title: "Confirm",
      message: "Are you sure you want to sign out?",
      positiveButton: "SIGN OUT",
    };

    this.view
      .showDialog(options)
      .then(async () => {
        await this.clearIndexedDB();
        return this.signOutUseCase.execute();
      })
      .then(() => {
        this.view.navigateTo("/signin");
      })
      .catch((error) => {
        this.view.showError(error);
      });
  }

  async signout() {
    await this.clearIndexedDB();
    await this.signOutUseCase.execute();
    this.view.navigateTo("/signin");
  }

  async clearIndexedDB() {
    try {
      await indexedDBService.clear();
    } catch (error) {
      console.error("Failed to clear IndexedDB:", error);
    }
  }

  startPolling() {
    this.pollingInterval = setInterval(() => {
      this.pollNotifs();
    }, 5000);
  }

  stopPolling() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
  }

  async pollNotifs() {
    const collection = "notifications";
    const user = this.view.getCurrentUser();
    const clientId = user?.client?.id || null;
    const query = {
      where: clientId ? { refId: clientId } : { refId: { $exists: false } },
      sort: { created: -1 },
      include: ["all"],
    };

    try {
      this.findObjectUseCase.abort();
      const notifications = await this.findObjectUseCase.execute(
        collection,
        query,
      );
      this.view.setState({ notifications });
    } catch (error) {
      console.error("Polling error:", error);
    }
  }
}

export default MainPagePresenter;
